import React, { useState } from 'react';
import { AvatarIcon, ListItemLayout, ListLayout } from '@keplerco/core';
import { FocusPanelLoaderLayer } from '../../../../../components/general/loading-state/loader-layers/focus-panel-loader-layer/focus-panel-loader-layer';
import { PagePath } from '../../../../../navigation/navigation.enums';
import { BulkUploadType } from '../../../../../enums/bulk-upload-type';
import { BulkUploadDto, FreemiumUserBulkUploadRow } from '../../../../../models/bulk-uploads/bulk-upload-dto';
import { FreemiumBulkUploadPreviewWidget } from '../../bulk-upload/bulk-upload-preview/freemium-bulk-upload-preview.widget';
import { useAppState } from '../../../../../overmind';
import managePersonPanelsStyles from '../../panels/manage-person-panels/freemium-manage-person-panels.module.css';
import * as base from '../../../../../overmind/actions/base';
import { BulkUpload } from '../../bulk-upload/freemium-bulk-upload.widget';
import BulkUploadEditFocusPanel from '../../bulk-upload/freemium-bulk-upload-edit.focus-panel';
export interface IFreemiumBulkUploadFocusPanelProps {
  onCancel: () => void
}

export function FreemiumBulkUploadFocusPanel(props: IFreemiumBulkUploadFocusPanelProps): JSX.Element {
  const { freemiumAccount } = useAppState();
  const [activeStep, setActiveStep] = useState<number>(0);
  const [editedRows, setEditedRows] = useState<Set<string>>(new Set());
  const [selectedRow, setSelectedRow] = useState<FreemiumUserBulkUploadRow | undefined>(undefined);
  const [data, setData] = useState<BulkUploadDto<FreemiumUserBulkUploadRow> | undefined>(undefined);

  function handleNextStep() {
    setActiveStep(prevStep => prevStep + 1);
  }

  function updateRow(updatedRow: FreemiumUserBulkUploadRow): void {
    setData(currentRows => {
      if (currentRows && currentRows.rows) {
        const rowIndex = currentRows.rows.findIndex(row => row.rowNumber === updatedRow.rowNumber);

        if (rowIndex !== -1) {
          const updatedData = [...currentRows.rows];
          updatedData[rowIndex] = { ...updatedRow };

          setEditedRows(currentEdited => {
            const newEditedRows = new Set(currentEdited);
            newEditedRows.add(updatedRow.email);
            return newEditedRows;
          });

          return { ...currentRows, rows: updatedData };
        }
      }
      return currentRows;
    });

    setSelectedRow(undefined);
  }

  function resetBulkUpload() {
    setData(undefined);
    setSelectedRow(undefined);
    setActiveStep(0);
  }

  return !!freemiumAccount ? (
    <FocusPanelLoaderLayer path={PagePath.freemiumUserManagementPeople}>
      <div className="panelContent">
        <header className={managePersonPanelsStyles.header}>
          <div className={managePersonPanelsStyles.avatar}>
            <AvatarIcon />
          </div>
          <h3>Bulk Upload People</h3>
        </header>

        <ListLayout>
          <ListItemLayout>
            {activeStep === 0 && (
              <div>
                <p>
                  Download <a href={base.apiURL(`bulkupload`, BulkUploadType.FreemiumUsers, `excel-template?companySlug=${freemiumAccount.companySlug}`)}>Excel</a> or
                  <a href={base.apiURL(`bulkupload`, BulkUploadType.FreemiumUsers, `csv-template?companySlug=${freemiumAccount.companySlug}`)}>CSV</a> template to get started with a bulk upload.
                </p>
                <br />
                <BulkUpload
                  onCancel={props.onCancel}
                  bulkUploadType={BulkUploadType.FreemiumUsers}
                  onValidate={() => {
                    handleNextStep();
                  }}
                  setData={setData}
                />
              </div>
            )}

            {activeStep >= 1 && data && (
              <div>
                <h4>Upload Preview</h4>
                <p>Take a moment to review your bulk upload preview, ensuring accuracy before finalising, and make any necessary adjustments to guarantee seamless data integration.</p>
                <FreemiumBulkUploadPreviewWidget
                  setEditedRows={setEditedRows}
                  setData={setData}
                  onCancel={props.onCancel}
                  data={data}
                  editedRows={editedRows}
                  setSelectedRow={row => {
                    setSelectedRow(row);
                  }}
                  next={handleNextStep}
                  reset={resetBulkUpload}
                />
              </div>
            )}
          </ListItemLayout>
        </ListLayout>
      </div>

      {selectedRow && (
        <BulkUploadEditFocusPanel
          selectedRow={selectedRow}
          onSubmit={updateRow}
        />
      )}
    </FocusPanelLoaderLayer>
  ) : <></>;
}
